import FullScreenLoadingComponent from './FullScreenLoadingComponent';
export default FullScreenLoadingComponent;
